export default {
    enabled: true,
    debug: false,
    trackOnNextTick: false,
    queryParams: {},
    loadScript: true,
}



// WEBPACK FOOTER //
// ./src/plugins/vue-gtm/config.js